<template>
  <HeaderComponent></HeaderComponent>
  <div align="center">
    <div
      class="imprint"
      align="start"
      style="font-family: Verdana, Geneva, Tahoma, sans-serif"
    >
      <h1 class="mt-10" style="font-size: xxx-large">{{ $t('imprint.title') }}</h1>
      <br />
      <div>
        <h3 style="font-size: xx-large">{{ $t('imprint.legal_info') }}</h3>
        <br />
        {{ $t('imprint.company_name') }}<br />
        {{ $t('imprint.street') }}<br />
        {{ $t('imprint.city_code') }} <br />
        <a href="mailto:paras@dwivedi.eu">{{ $t('imprint.email') }}</a>
        <br />
      </div>
      <br />
      <div>
        <h3>{{ $t('imprint.represented_by') }}</h3>
        {{ $t('imprint.representative') }}<br />
      </div>
      <br />
      
      <div>
        <h3>{{ $t('imprint.registration') }}</h3>
        {{ $t('imprint.register_entry') }}<br />
        {{ $t('imprint.register_court') }}<br />
        {{ $t('imprint.register_number') }}<br />
      </div>
      <br />
      
      <div>
        <h3>{{ $t('imprint.vat_id_title') }}</h3>
        {{ $t('imprint.vat_id') }}<br />
      </div>
      <br />

      <div>
        <h3>{{ $t('imprint.responsible_content') }}</h3>
        <br />
        {{ $t('imprint.responsible_person') }} <br />
        {{ $t('imprint.responsible_street') }}<br />
        {{ $t('imprint.responsible_city') }} <br />
      </div>
      <br />

      <div>
        <h3>{{ $t('imprint.disclaimer') }}</h3>
        <h3>{{ $t('imprint.liability_content') }}</h3>
        {{ $t('imprint.liability_content_text') }}
        <br /><br />
        <h3>{{ $t('imprint.liability_links') }}</h3>
        {{ $t('imprint.liability_links_text') }}
        <br /><br />
        <h3>{{ $t('imprint.copyright') }}</h3>
        {{ $t('imprint.copyright_text') }}
      </div>
    </div>
  </div>
  <FooterComponent></FooterComponent>
</template>

<script setup lang="ts">
import FooterComponent from "@/components/Footer/FooterComponent.vue"
import HeaderComponent from "@/components/Header/HeaderComponent.vue"
import { computed } from "vue"
import { useI18n } from "vue-i18n"
import { useMeta } from "vue-meta"
FooterComponent
const { t } = useI18n()
useMeta(
  computed(() => ({
    title: t("meta.imprint"),
  }))
)
</script>

<style scoped>
.imprint {
  width: 70%;
}
@media screen and (max-width: 800px) {
  .imprint {
    width: 90%;
  }
}
</style>
